import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { SharedModulesModule } from '../../shared/shared-modules.module';

export const defaultConfirmation = {
  confirmType: 'Confirm',
  dialog: 'Are you sure you want to proceed with this action?'
}

export const defaultDeletion = {
  confirmType: 'Delete',
  dialog: 'Are you sure you want to delete this item? This action cannot be undone.'
}

@Component({
  selector: 'app-confirmation-dialog',
  templateUrl: './confirmation-dialog.component.html',
  styleUrls: ['./confirmation-dialog.component.scss'],
  imports: [
    SharedModulesModule
  ],
})
export class ConfirmationDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<ConfirmationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data?: { confirmType: string, dialog: string }
  ) {
    if (!data) {
      this.data = defaultConfirmation;
    }
  }

  onCancel(): void {
    this.dialogRef.close(false);
  }

  onConfirm(): void {
    this.dialogRef.close(true);
  }
}